import React, { useEffect } from 'react';
import { PageProps } from 'gatsby';
import Layout from 'src/elements/Layout/2023_Q4/Layout';
import FreeTrialForm from 'src/molecules/Standard/Shared/FreeTrialForm/FreeTrialForm';
import useOnMobile from 'src/hooks/useOnMobile';
import { palette } from 'src/styles/colors';
import { PeopleMagicDesignControllerProvider } from 'src/hooks/usePeopleMagicDesignController';
import OpportunityCalculatorStatic from 'src/organisms/Standard/Homepage/2024_Q1_people_magic/OpportunityCalculator/OpportunityCalculatorStatic';
import MeetMightyProStatic from 'src/organisms/Standard/Homepage/2024_Q1_people_magic/MeetMightyPro/MeetMightyProStatic';
import { HomepageStaticWrapper } from 'src/molecules/Standard/Homepage/2024_Q4/HomepageStaticWrapper/homepage_static.styles';
import CommunityBusinessHeroStatic from 'src/organisms/Standard/Homepage/2024_Q4/CommunityBusinessHeroStatic/CommunityBusinessHeroStatic';
import FromIdeaToLiveCommunityStatic from 'src/organisms/Standard/Homepage/2024_Q4/FromIdeaToLiveCommunityStatic/FromIdeaToLiveCommunityStatic';
import TapIntoMagic from 'src/organisms/Shared/TapIntoMagic/TapIntoMagic';
import WhoElseOnMighty from 'src/organisms/Standard/Homepage/2024_Q4/WhoElseOnMighty/WhoElseOnMighty';
import { useTopInfoBarController } from 'src/hooks/useTopInfoBarController';
import { TopInfoBarCustomStyles } from 'src/organisms/Shared/Layout/TopInfoBar/Layouts/PeopleMagicProfitAnnouncementBar.styles';
import { TopInfoBarCustomStylesForNovemberOffer } from 'src/organisms/Shared/Layout/TopInfoBar/Layouts/NovemberOfferAnnouncement.styles';
import getQueryParams from 'src/functions/getQueryParams';

export interface HomepageProps extends PageProps {
  data: {
    contentfulPage: {
      seoTitle: string;
      seoDescription?: string;
      canonicalTagSlug?: string;
      seoImage?: {
        file?: {
          url: string;
        };
      };
    };
  };
}

const HomepageStaticBase = (props: PageProps): JSX.Element => {
  const isMobile = useOnMobile(1250);

  return (
    <Layout
      location={props.location}
      bodyBackgroundColor={palette.cream}
    >
      <HomepageStaticWrapper>
        <CommunityBusinessHeroStatic />
        <FromIdeaToLiveCommunityStatic />
        <TapIntoMagic />
        <OpportunityCalculatorStatic />
        <MeetMightyProStatic />
        <WhoElseOnMighty />
        <FreeTrialForm
          mobile={isMobile}
          scale={false}
        />
      </HomepageStaticWrapper>
    </Layout>
  );
};

const HomepageView = (props: PageProps): JSX.Element => {
  const { show } = useTopInfoBarController();

  useEffect(() => {
    const queryParams = getQueryParams();

    if (queryParams['inactive_network'] === '1' && show) {
      show({
        dismissible: true,
        contentLayout: 'inactiveNetworks',
      });
    } else {
      // Only available until December 1st, 2024 00:00 Pacific
      if (Date.now() < new Date('12/01/2024 00:00:00 GMT-08:00').getTime()) {
        show({
          dismissible: true,
          contentLayout: 'novemberOfferAnnouncement',
          permanentDismissKey: 'dismissedNovemberOfferAnnouncement',
          backgroundColor: 'greyText',
          dismissButtonColor: 'white',
          customStyles: TopInfoBarCustomStylesForNovemberOffer,
        });
      } else {
        show({
          dismissible: true,
          contentLayout: 'peopleMagicProfitAnnouncement',
          permanentDismissKey: 'dismissedPeopleMagicProfitAnnouncement_1',
          backgroundColor: 'greyText',
          dismissButtonColor: 'white',
          customStyles: TopInfoBarCustomStyles,
        });
      }
    }
  }, []);

  return (
    <PeopleMagicDesignControllerProvider>
      <HomepageStaticBase {...props} />
    </PeopleMagicDesignControllerProvider>
  );
};

export default HomepageView;
